import React, { useContext } from 'react';
import t from '@/utils/Language/UI-translations';
import Button from '@/components/Button/Button';
import { modalContext } from '@/context/modal.context';
import { AccountContext } from '@/context/account.context';
import { viewportContext } from '@/context/viewport.context';
import { collectionContext } from '@/context/collection.context';

const AddToCollectionButton = ({
  resource,
  buttonType,
  buttonShape,
  buttonBorder,
  hideOnMobile,
  additionalClasses,
  showButtonTextOnMobile = false,
  showButtonText = true,
  buttonText: buttonTextOverride,
  buttonIcon,
  onChange
}) => {
  const { enqueueModal } = useContext(modalContext);
  const account = useContext(AccountContext);
  const { isXs } = useContext(viewportContext);
  const { refreshCollection } = useContext(collectionContext);

  const handleClick = () => {
    if (account?.state?.isLoggedIn) {
      enqueueModal({
        name: 'AddToCollectionModal',
        onChange: onChange || refreshCollection || (() => {}),
        resource: resource,
        teamsList: false,
        excludeCollectionId: resource.resourceType === 'Collection' || resource.resource_type === 'Collection' ? resource.id : null
      });
    } else {
      enqueueModal({
        name: 'SignupModal'
      });
    }
  };

  const buttonText = () => {
    if (!showButtonText) return '';
    if (!showButtonTextOnMobile && isXs) return '';
    return buttonTextOverride || t('Collections');
  };

  return (
    <Button
      type={buttonType || 'default'}
      border={buttonBorder || false}
      shape={buttonShape || 'pill'}
      text={buttonText()}
      icon={buttonIcon || { style: 'fas', font: 'book' }}
      additionalClasses={additionalClasses}
      styles={{ hidden: isXs && hideOnMobile }}
      onButtonClick={handleClick}
    />
  );
};

export default AddToCollectionButton;
